<template>
  <div>
    <search-module-inventory-import-records @submit="submitSearch" />

    <a-table
      size="middle"
      :scroll="{ x: 'max-content' }"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="false"
      row-key="id"
    >
      <div slot="operation_no" slot-scope="operation_no, record">
        <router-link :to="{ name: 'batch_operation_record_info', params: { id: record.id }}">
          {{ operation_no }}
        </router-link>
      </div>
    </a-table>

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />
  </div>
</template>

<script>
import { findModuleInventoryImportRecords } from '@/api/module_inventory'
import Pagination from '@/components/Pagination'
import SearchModuleInventoryImportRecords from '@/views/module_inventories/import_records/Search'

export default {
  name: 'ModuleInventoryImportRecords',
  components: {
    SearchModuleInventoryImportRecords,
    Pagination
  },
  data() {
    return {
      data: [],
      loading: true,
      pagination: {
        total_count: 0
      },
      query: {},
      columns: [
        {
          title: '入库批次',
          dataIndex: 'operation_no',
          fixed: 'left',
          width: 120,
          scopedSlots: { customRender: 'operation_no' }
        },
        {
          title: '模组厂商',
          width: 120,
          dataIndex: 'module_producer_name'
        },
        {
          title: '模组型号',
          width: 140,
          dataIndex: 'module_model_name'
        },
        {
          title: '入库成功数',
          width: 100,
          dataIndex: 'success_count'
        },
        {
          title: '出库数',
          width: 90,
          dataIndex: 'allocated_count'
        },
        {
          title: '库存数',
          width: 90,
          dataIndex: 'inventory_count'
        },
        {
          title: '采购日期',
          width: 120,
          dataIndex: 'purchase_date'
        },
        {
          title: '供应商',
          width: 140,
          dataIndex: 'module_supplier_name'
        },
        {
          title: '采购主体',
          width: 140,
          dataIndex: 'contracting_party_name'
        },
        {
          title: '固件版本',
          width: 120,
          dataIndex: 'firmware_version'
        },
        {
          title: '税点',
          width: 100,
          dataIndex: 'invoice_rate_name'
        },
        {
          title: '单价',
          width: 100,
          dataIndex: 'unit_price'
        },
        {
          title: '总价',
          width: 100,
          dataIndex: 'total_price'
        },
        {
          title: '备注',
          width: 160,
          ellipsis: true,
          dataIndex: 'remark'
        },
        {
          title: '入库时间',
          fixed: 'right',
          width: 180,
          dataIndex: 'created_at'
        }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    submitSearch(search) {
      this.query = Object.assign({},
        this.$options.data().query,
        { per_page: this.query.per_page },
        search)
      this.fetchData()
    },

    fetchData() {
      this.loading = true
      findModuleInventoryImportRecords(this.query).then((res) => {
        this.data = res.data
        this.pagination = res.pagination
        this.loading = false
      })
    }
  }
}
</script>
